export const roleColumnVisibilityMap: Record<number, string[]> = {
  [-1]: [],
  [-2]: ['entityLabel'],
  [1]: ['entityLabel', 'projectLabel'],
  [2]: ['entityLabel', 'projectLabel', 'securityGroupName'],
};
